import React from "react"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons"
import styled from "styled-components"
import Text from "./Text"

const Icon = styled(FontAwesomeIcon)`
  color: #b22222;
  margin-right: 0.5rem;
`

const ErrorMsg = ({ msg, showIcon = false, showMsg = true }) => (
  <Text error>
    {showIcon && <Icon title={msg} icon={faTriangleExclamation} />}
    {showMsg && <span>{msg}</span>}
  </Text>
)

ErrorMsg.propTypes = {
  msg: PropTypes.string.isRequired,
  showIcon: PropTypes.bool,
  showMsg: PropTypes.bool,
}

export default ErrorMsg
